/**
 * SECOND LIFE STORIES — the "what happens after pickup" section.
 *
 * ✏️ HOW TO UPDATE (for Julio & Nick):
 *   - Each story is one video card: edit titles/captions in BOTH en and es.
 *   - To swap a video: drop the new file + poster in public/ and change the
 *     `video` / `poster` paths below. Keep videos silent, short and compressed
 *     (ask Claude to run them through ffmpeg). New Higgsfield renders slot in
 *     the same way — no component changes needed.
 *   - The first story with `wide: true` renders as the big featured film.
 */

export type Story = {
  id: string;
  video: string;
  poster: string;
  wide?: boolean;
  title: { en: string; es: string };
  caption: { en: string; es: string };
};

export const JOURNEY_COPY = {
  title: { en: "Watch it get a second life.", es: "Míralo recibir una segunda vida." },
  sub: {
    en: "This is what happens to what you give us — from your curb to its next chapter.",
    es: "Esto es lo que pasa con lo que nos das — de tu acera a su próximo capítulo.",
  },
  cta: { en: "Schedule a Free Pickup", es: "Agenda tu Recogida Gratis" },
  eligible: {
    en: "Eligible items may qualify for free scheduled pickup.",
    es: "Los artículos elegibles pueden calificar para recogida gratis programada.",
  },
};

export const STORIES: Story[] = [
  {
    id: "van",
    video: "/journey-van.mp4",
    poster: "/journey-van-poster.jpg",
    wide: true,
    title: { en: "The pickup", es: "La recogida" },
    caption: {
      en: "Domino Park, Williamsburg. One visit and the clutter's gone — loaded with care and headed for its next chapter.",
      es: "Domino Park, Williamsburg. Una visita y se acabó el reguero — cargado con cuidado y rumbo a su próximo capítulo.",
    },
  },
  {
    id: "laptop",
    video: "/journey-laptop.mp4",
    poster: "/journey-laptop-poster.jpg",
    title: { en: "Laptops & electronics", es: "Laptops y electrónicos" },
    caption: {
      en: "Cleaned, repaired and refurbished whenever possible — working tech goes on to students, families and neighbors.",
      es: "Se limpian, se reparan y se reacondicionan siempre que se puede — la tecnología que funciona llega a estudiantes, familias y vecinos.",
    },
  },
  {
    id: "clothing",
    video: "/journey-clothing.mp4",
    poster: "/journey-clothing-poster.jpg",
    title: { en: "Clothing & textiles", es: "Ropa y textiles" },
    caption: {
      en: "Sorted with care and passed on to people who can really use it — the rest is responsibly recycled.",
      es: "Se clasifica con cuidado y se entrega a quien de verdad la necesita — el resto se recicla responsablemente.",
    },
  },
  {
    id: "toys",
    video: "/journey-toys.mp4",
    poster: "/journey-toys-poster.jpg",
    title: { en: "Toys & treasures", es: "Juguetes y tesoros" },
    caption: {
      en: "A little cleaning and repair, and a toy someone outgrew becomes another kid's favorite.",
      es: "Un poco de limpieza y reparación, y el juguete que alguien dejó atrás se vuelve el favorito de otro niño.",
    },
  },
];
